module.exports = __webpack_public_path__ + "static/media/competitors.434d1471.png";